import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StorageItem, StorageItemWithIngredient } from "../../shared/models/storage-item.model";
import { environment } from "../../../environments/environment";
import { QuotaInfo } from "../../shared/models/quota-info.model";
import { StorageDeleteReason } from "../../shared/enums/storage.enum";

@Injectable({ providedIn: 'root' })
export class StorageService {
  private static readonly BASE_URL = `${environment.apiUrl}/storage`;

  constructor(private http: HttpClient) {}

  getStorageItems(): Observable<StorageItemWithIngredient[]> {
    return this.http.get<StorageItemWithIngredient[]>(StorageService.BASE_URL);
  }

  getStorageQuota(): Observable<QuotaInfo> {
    return this.http.get<QuotaInfo>(`${StorageService.BASE_URL}/quota`);
  }

  addStorageItem(storageItem: Omit<StorageItem, 'storage_id'>): Observable<StorageItemWithIngredient> {
    return this.http.post<StorageItemWithIngredient>(StorageService.BASE_URL, storageItem);
  }

  updateStorageItem(
    id: number,
    storageItem: Partial<StorageItem>
  ): Observable<StorageItemWithIngredient> {
    return this.http.put<StorageItemWithIngredient>(
      `${StorageService.BASE_URL}/${id}`,
      storageItem
    );
  }

  bulkAddStorageItems(
    items: Array<Partial<StorageItem>>
  ): Observable<StorageItemWithIngredient[]> {
    return this.http.post<StorageItemWithIngredient[]>(
      `${StorageService.BASE_URL}/bulk-add`,
      items
    );
  }

  bulkUpdateStorageItems(
    items: Array<{ storage_id: number } & Partial<StorageItem>>
  ): Observable<StorageItemWithIngredient[]> {
    return this.http.put<StorageItemWithIngredient[]>(
      `${StorageService.BASE_URL}/bulk-update`,
      items
    );
  }

  bulkDeleteStorageItems(ids: number[]): Observable<void> {
    return this.http.post<void>(`${StorageService.BASE_URL}/bulk-delete`, ids);
  }

  deleteStorageItem(id: number, reason: StorageDeleteReason): Observable<void> {
    return this.http.delete<void>(`${StorageService.BASE_URL}/${id}`, {
      body: { reason }
    });
  }

}
